// extracted by mini-css-extract-plugin
export default {"info":"nba-page_info__v9zFU"};